/* global APPLICATION_CONFIG */
import c from "./consts";
import http from "@/api/http";

export default {
    async [c.INIT_COMPANY_DATA](
        {
            dispatch,
            commit,
        },
        companyContext = null
    ) {
        /*
         * Удаляем данные предыдущей компании,
         * чтобы они не показывались во время загрузки.
         */
        commit(c.COMPANY_DISPLAYS, []);
        commit(c.STORM_WARNINGS, []);

        let company = companyContext;

        /*
         * Если компания не передана, значит страницу
         * открыл обычный пользователь компании.
         */
        if (!company) {
            company = await dispatch(c.GET_COMPANY);
        }
        else {
            /*
             * Если компания передана, её выбрал
             * администратор в dropdown.
             */
            commit(c.COMPANY, company);
        }

        if (!company?.id) {
            commit(c.COMPANY, null);
            return;
        }

        await Promise.all([
            dispatch(
                c.GET_STORM_WARNINGS,
                company.id
            ),

            dispatch(
                c.GET_COMPANY_DISPLAYS,
                company.id
            ),
        ]);
    },

    async [c.CREATE_FORECAST_DOCUMENT](
        _,
        companyId
    ) {
        const response = await http.get(
            `${APPLICATION_CONFIG.api.companyURL}/create-forecast-document`,
            {
                params: {
                    companyId
                },
                responseType: "blob"
            }
        );

        return response.data;
    },

    async [c.GET_STORM_WARNING_HISTORY](
        _,
        {
            companyId,
            date
        }
    ) {
        try {
            const result = await http.get(
                `${APPLICATION_CONFIG.api.companyURL}/get-storm-warning-history`,
                {
                    params: {
                        companyId,
                        date
                    }
                }
            );

            return result.data;
        }
        catch (error) {
            console.error(
                "Не удалось загрузить архив предупреждений",
                error
            );

            return null;
        }
    },

    async [c.GET_COMPANY] ({ commit }) {
        try {
            let result = await http.get(`${APPLICATION_CONFIG.api.companyURL}/get-company`)

            commit(c.COMPANY, result.data)
            return result.data;
        }
        catch (err) {
            console.log(err);
            return null;
        }
    },

    async [c.GET_COMPANY_DISPLAYS] ({ commit }, companyId) {
        try {
            let result = await http.get(`${APPLICATION_CONFIG.api.companyURL}/get-company-displays`, {
                params: {
                    companyId
                }
            })

            commit(c.COMPANY_DISPLAYS, result.data)
        }
        catch (err) {
            console.log(err);
        }
    },

    async [c.GET_STORM_WARNINGS] ({ commit }, companyId) {
      try {
          let result = await http.get(`${APPLICATION_CONFIG.api.companyURL}/get-storm-warnings`, {
              params: {
                companyId
              }
          });

          commit(c.STORM_WARNINGS, result.data);
      }
      catch (err) {
          console.log(err);
      }
    },

    async [c.GET_LOCATION_FORECASTS] (_, { companyId, locationId }) {
        try {
            const result = await http.get(
                `${APPLICATION_CONFIG.api.companyURL}/get-location-forecasts`,
                {
                    params: {
                        companyId,
                        locationId
                    },
                    paramsSerializer: {
                        indexes: null
                    }
                }
            );

            return result.data;
        }
        catch (err) {
            console.log(err);
            return [];
        }
    },

    async [c.GET_STATION_CHARTS] (_, companyId) {
        try {
            const result = await http.get(
                `${APPLICATION_CONFIG.api.companyURL}/get-station-charts`,
                {
                    params: {
                        companyId
                    },
                    paramsSerializer: {
                        indexes: null
                    }
                }
            );

            return result.data;
        }
        catch (err) {
            console.log(err);
            return [];
        }
    }

};